(function () {
    'use strict';

    angular.module("imApp").factory("p2UpdateProceduresService", ['$ihttp', function ($ihttp) {
        let service = {
            getUpdateProcedure: function (parms) {
                return $ihttp.post({
                    method: 1601,
                    parameters: parms || {}
                });
            },
            listUpdateProcedures: function (parms) {
                return $ihttp.post({
                    method: 207,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
